import React, { useState } from "react";
import '../styles/Testimonial.css';
import Masinga from '../images/gallery/image11.jpeg';

const Testimonial = () =>{
    const [activeView, setActiveView] = useState('Video');
    
    const showVideo = () =>{
        setActiveView('Video');
    }

    const showReviews = () =>{
        setActiveView('Review')
    }

    const isActive = (view) => activeView === view;
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    const currentDate = day + '/' + month + '/' + year;

    return(
        <>
        <title>Zuri Lands Investment Limited - Testimonial</title>
        <section className="testimonial_container">
            <div className="header_container">
              <h2 className="main_heading">Changing Dreams into Reality</h2>
              <h4 className="sub_heading"> The true measure of our work? Their stories..</h4>
            </div>
            <div className="button_container">
                <button className={`video_button ${isActive('Video') ? 'active' : ''}`} onClick={showVideo}>Video</button>
                <button className={`review_button ${isActive('Review') ? 'active' : ''}`} onClick={showReviews}>Reviews</button>
            </div>
         {/* Conditional Rendering */}   
    {activeView === 'Video' && (
     <div className="videos">
          <div className="first_column">
           <div className="video_container">
                <iframe 
                    className="video_frame"
                    src="" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allowFullScreen
                ></iframe>
                  {/*}  <div className="video_overlay">
                       <h1 className="video_title">Video Title</h1>
                       <p className="video_description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at nunc nec ligula facilisis facilisis. Integer euismod.</p>
                    </div>*/}
             
           </div>  
           <div className="video_description">
                <h5 className="video_heading">Video Heading</h5>
                <p className="video_text">Masinga Dam Breeze Title Deed Issuance.</p>

           </div>
          </div>
         <div className="second_column">
            <div className="container_body">
             <div className="heading">
                 <h1 className="heading_pry">More Videos</h1>
             </div>
             <div className="more_container">
                <div className="preview_container">
                    <div className="thumbnail">
                        <img src={Masinga} alt="Thumbnail" className="thumbnail_image" />
                    </div>

                    <div className="preview_description">
                        <p className="preview_text">They Kept Their Word,Now I Finally Have My Title!</p>
                    </div>

                </div>
             </div>
            </div>

         </div>
     </div>
    )}

    {activeView === 'Review' && (
        <div className="reviews">
            <div className="review_form">
                <div className="review_header">
                  <h3 className="review_heading">Share Your Experience</h3>
                   <p className="review_header_text">We value your feedback! Please fill out the form below to share your experience with us.</p>
                   <p className="review_header_text">Your feedback helps us improve our services and provide the best experience for our clients.</p>
                </div>
                
               <form className="review-form">
                   <div className="form-group">
                     <label htmlFor="name">Name:</label>
                     <input type="text" id="name" name="name" required />
                   </div>
            
                   <div className="form-group">
                     <label htmlFor="email">Email:</label>
                     <input type="email" id="email" name="email" required />
                   </div>
            
                   <div className="form-group">
                     <label htmlFor="message">Message:</label>
                     <textarea id="message" name="message" rows="5" required></textarea>
                   </div>
            
                 <button type="submit" className="submit_btn">Send Review</button>
               </form>
            </div>
            <div className="review_container">
                <div className="review_header">
                   <h3 className="review_heading">Client Reviews</h3>
                </div>
                <div className="review_card">
                    <p className="review_author">John Doe</p>
                    <p className="review_text"><q>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque at nunc nec ligula facilisis facilisis. Integer euismod.</q></p>
                    <p className="review_date">{currentDate}</p>
                </div>
            </div>
        </div>


    )}
        
        </section>
        
        </>
    );
}
export default Testimonial;